import React__default from 'react';
import { useFocusLock, FocusGuard } from './focus-layers/useFocusLock.js';
import { useCombinedRef } from '@doordash/utilities';

var getIsReactElement = function getIsReactElement(child) {
  if (typeof child === 'string' || typeof child === 'number') {
    return false;
  }

  if (child.type && child.type === React__default.Fragment) {
    return false;
  }

  return true;
};

var FocusLockWrapper = function FocusLockWrapper(_ref) {
  var children = _ref.children,
      returnRef = _ref.returnRef,
      getInitialFocusElement = _ref.getInitialFocusElement,
      getReturnRef = _ref.getReturnRef,
      attachToRef = _ref.attachToRef;
  var containerRef = React__default.useRef(null);
  useFocusLock(containerRef, {
    getInitialFocusElement: getInitialFocusElement,
    returnRef: returnRef,
    getReturnRef: getReturnRef,
    attachToRef: attachToRef
  });
  var firstChild = React__default.Children.only(children); // TODO: replace with more explicit element type that includes `ref`

  var childIsReactElement = getIsReactElement(firstChild);
  var existingInnerRef = childIsReactElement ? firstChild.ref : undefined;
  var combinedRef = useCombinedRef(existingInnerRef, containerRef);

  if (!childIsReactElement) {
    console.error('You can not pass a non element as the child of FocusLock');
    return null;
  }

  var childWithRef = /*#__PURE__*/React__default.cloneElement(firstChild, {
    ref: combinedRef
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FocusGuard, null), childWithRef, /*#__PURE__*/React__default.createElement(FocusGuard, null));
};

var FocusLock = function FocusLock(_ref2) {
  var disableFocusLock = _ref2.disableFocusLock,
      getInitialFocusElement = _ref2.getInitialFocusElement,
      returnRef = _ref2.returnRef,
      getReturnRef = _ref2.getReturnRef,
      attachToRef = _ref2.attachToRef,
      children = _ref2.children;

  if (disableFocusLock) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }

  return /*#__PURE__*/React__default.createElement(FocusLockWrapper, {
    getInitialFocusElement: getInitialFocusElement,
    returnRef: returnRef,
    getReturnRef: getReturnRef,
    attachToRef: attachToRef
  }, children);
};

export { FocusLockWrapper, FocusLock as default };
